<template>
  <SalesContainer :config="config" />
</template>

<script>
import SalesContainer from "../../components/SalesContainer/SalesContainer.vue";

export default {
  name: "app",
  components: {
    SalesContainer
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
